import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// Se você estiver no supabase-js v2:
export const supabaseAcor = createClient(supabaseUrl, supabaseAnonKey, {
  db: { schema: 'acor' },
  auth: { persistSession: true },
});

// OBS: Se seu projeto estiver no supabase-js v1 (o erro "supabase.schema is not a function" sugere isso),
// o campo "db.schema" não existe. Nesse caso, duas opções:
// (A) atualizar para supabase-js v2 (recomendado), OU
// (B) manter uma view pass-through em public (você disse que não curte),
//     pois o v1 não tem uma maneira simples de mudar o schema por client.
